import * as types from '../actions/dialog/types';

const INITIAL_STATE = {
  open: false,
  error: false,
  title: '',
  content: '',
};

export default function(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.ALERT_DIALOG:
      return action.payload;

    default: return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/alertDialogReducer.js